<template>
    <transition name="modal">
        <slot></slot>
    </transition>
</template>

<style lang="scss">
    /*! purgecss start ignore */
    .modal {
        &-enter-active {
            transition: opacity 0.2s ease-out;
        }

        &-leave-active {
            transition: opacity 0.1s ease-out;
        }

        &-enter,
        &-leave-active {
            opacity: 0;
        }

        &-enter-active &__window {
            transition: opacity 0.2s ease-out, transform 0.1s ease-out;
        }

        &-leave-active &__window {
            transition: opacity 0.1s ease-out, transform 0.1s ease-out;
        }

        &-enter &__window,
        &-leave-active &__window {
            transform: scale(0.9);
        }
    }
    /*! purgecss end ignore */
</style>
